{
  "overlay": {
    "viewArchive": {
      "title": "ஆவணக்காப்பகத்தைப் பார்க்க",
      "description": "முந்தைய இதழ்களுக்கு இங்கே செல்க"
    },
    "startReading": {
      "title": "படிக்கத் தொடங்குக",
      "description": "இப்பொத்தானை அழுத்தி இன்றைய இதழை வாசிக்கலாம்"
    }
  },
  "tutorials": [
    {
      "title": "தொடங்கலாம்",
      "body": "வாசகர்கள் சிறந்த அனுபவம் பெற ஏதுவாக விரைவான அணுகுவழி, செய்திக் காப்பகம், விரிவான செய்திப் பக்கம் ஆகியவற்றை உள்ளடக்கியுள்ளோம். மேல் விவரங்கள் பயிற்சி வழிகாட்டியில்"
    },
    {
      "title": "விரிவான செய்தி",
      "body": "மேம்பட்ட வாசிப்பு அனுபவத்தைப் பெற, ஒரு செய்தியைச் சொடுக்கி, விரிவான செய்தியைக் காணுங்கள் (சந்தாதாரர்களுக்கு மட்டும்)"
    },
    {
      "title": "முந்திய நாள்களின் இதழ்களைப் படிக்க",
      "body": "முந்திய நாள்களின் மின்னிதழ்களைப் படிக்க"
    },
    {
      "title": "அனைத்துப் பக்கங்களுக்கும் விரைவான அணுகுவழி",
      "body": "பக்க முன்தோற்றத்தைக் கண்டபின் மற்றப் பக்கங்களுக்கோ பகுதிகளுக்கோ செல்லலாம்"
    },
    {
      "title": "கூடுதல் பதிப்புகளுக்கு நாடவும்",
      "body": "செய்திகள் எவற்றையேனும் முன்னர்த் தவறவிட்டிருந்தால் அண்மைய செய்திகள்மூலம் அவற்றை அறிந்திடுங்கள்"
    },
    {
      "title": "படத்தைப் பதிவிறக்குதல்",
      "body": "பக்கத்தை உங்கள் கருவியில் படமாகச் சேமிக்கவும்"
    },
    {
      "title": "செய்திப் பகிர்வு",
      "body": "இணைப்பை அனுப்ப 'பகிர்' படவுருவைத் தட்டவும்"
    },
    {
      "title": "காட்சிநிலைகளுக்கு இடையில் மாற",
      "body": "இருநிலைமாற்றி மூலம் செய்தி, அச்சுப் பார்வைக்கு இடையே மாற"
    }
  ]
}
